import React, { useEffect, useState } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

const StyleBar = ({ min, max, styleMin, styleMax, actual, unit }) => {
  const [actualPerc, setActualPerc] = useState(null);
  const [minPerc, setMinPerc] = useState(null);
  const [maxPerc, setMaxPerc] = useState(null);

  useEffect(() => {
    if (actual != null && !isNaN(actual)) {
      let actualPer = ((actual - min) / (max - min)) * 96;
      if (+actualPer > 96) {
        actualPer = 96;
      } else if (+actualPer < 0) {
        actualPer = 0;
      }
      setActualPerc(actualPer);
    } else {
      setActualPerc(null);
    }

    let minPer = ((styleMin - min) / (max - min)) * 100;
    minPer = Math.max(0, Math.min(100, minPer));
    setMinPerc(minPer);

    let maxPer = ((styleMax - min) / (max - min)) * 100;
    maxPer = Math.max(0, Math.min(100, maxPer));
    setMaxPerc(Math.max(0, 100 - maxPer));
  }, [min, max, styleMin, styleMax, actual]);

  const hasActual = actual != null && !isNaN(actual);

  const helloStyle =
    hasActual && actualPerc !== null
      ? {
          backgroundColor:
            +actual >= +styleMin && +actual <= +styleMax ? "green" : "red",
          height: "10px",
          width: "10px",
          left: actualPerc + "%",
          borderRadius: "5px",
          position: "absolute",
          zIndex: 1,
        }
      : null;

  const minMaxStyle = {
    backgroundColor: "yellowgreen",
    height: "10px",
    left: minPerc + "%",
    right: maxPerc + "%",
    borderRadius: "5px",
    position: "absolute",
  };

  return (
    <div>
      {styleMin && styleMax ? (
        <OverlayTrigger
          trigger={["hover", "focus", "click"]}
          placement="bottom"
          overlay={
            <Popover id="popover-trigger-hover-focus">
              {`Min: ${styleMin} - Max: ${styleMax}${unit ? ` ${unit}` : ""}`}
            </Popover>
          }
        >
          <div
            style={{
              backgroundColor: "gainsboro",
              height: "10px",
              width: "100%",
              borderRadius: "5px",
              position: "relative",
              marginBottom: "10px",
              overflow: "hidden",
            }}
          >
            <div style={minMaxStyle} />
            {helloStyle && <div style={helloStyle} />}
          </div>
        </OverlayTrigger>
      ) : (
        <span style={{ fontFamily: "gotham-book", color: "black" }}>
          no guidelines
        </span>
      )}
    </div>
  );
};

export default StyleBar;
